export const VARIABLE_DRAG_MIME = 'application/x-emrald-variable';
